// @flow

import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { AuthGate, ExternalUser } from 'auth';
import Index from 'modules/external_tenant/components/index/IndexView';
import PageNotFound from 'components/PageNotFound';
import OwnerIndex from 'modules/external_tenant/components/owner/OwnerIndex';
import TenantReport from 'modules/external_tenant/components/tenant/TenantReportWithContext';
import RenterApplication from 'views/renter_application/RenterApplicationComponent';
import CalculateEarningsHome from 'modules/external_tenant/components/CalculateEarningsHomeView';

class Routes extends Component<{}> {
  render() {
    return (
      <Switch>
        <Route exact path="/inquilinos-externos" component={Index} />
        <Route
          exact
          path="/inquilinos-externos/proceso-completado"
          render={props => <Index {...props} isHomeAppComplete={true} />}
        />
        <Route
          exact
          path="/inquilinos-externos/:user_id/aplicaciones/:homeApplicationId/completada"
          render={props => <Index {...props} isHomeAppComplete={true} />}
        />
        <Route
          exact
          path="/inquilinos-externos/:user_id/aplicaciones/:home_app_id/editar/:step?"
          render={props => (
            <AuthGate allowed={[ExternalUser]}>
              <RenterApplication {...props} app_type={'externo'} />
            </AuthGate>
          )}
        />
        <Route
          exact
          path="/inquilinos-externos/aplicaciones/:homeApplicationId/registro/inmueble/:home_id/:step?"
          component={CalculateEarningsHome}
        />
        <Route
          exact
          path="/inquilinos-externos/aplicaciones/:homeApplicationId/invitacion"
          component={OwnerIndex}
        />
        <Route
          exact
          path="/inquilinos-externos/:userId/aplicaciones/:homeApplicationId/reporte/:token"
          component={TenantReport}
        />
        <Route component={PageNotFound} />
      </Switch>
    );
  }
}

export default withRouter(Routes);
